import React from "react";
import CBannerSection from "../Corporate/cBannerSection";
import AboutSection from "./aboutSection";
import { CVideoSection } from "../Corporate/cVideoSection";
import { RentalHighlights } from "./rentalHighlights";
import RentalGuidelines from "./rentalGuidelines";
import Popularrentalitems from "./popularRentalitems";
import { Categories } from "./categories";
import { DecorationCategories } from "./decorationCategories";

function designAndDecor() {
  return (
    <>
      <CBannerSection id={6} />
      <AboutSection id={6} />
      <RentalHighlights />
      <Popularrentalitems />
      <Categories />
      <DecorationCategories />
      <CVideoSection id={6} />
      <RentalGuidelines />
    </>
  );
}

export default designAndDecor;
